import { useQuery } from "@tanstack/react-query";
import type { IServiceStatusResponse } from "../types/types";
import { getServiceStatus } from "./status.api";

export const useGetServiceStatus = () => {
  return useQuery<IServiceStatusResponse, Error>({
    queryKey: ["service-status"],
    queryFn: getServiceStatus,
    staleTime: 30_000, // 30s — status doesn't change by the second
  });
};
